import React, { useEffect, useState } from "react";
import DateRange from "../../Component/DateRange/DateRange";
import { Table } from "../../Component/Table/Table";
import { admin_list } from "../redux/api/dummyJson";
import ScreenPagination from "../../Component/ScreenPagination/ScreenPagination";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { Toast } from "../../Component/Toast";
import moment from "moment/moment";
import useStore from "../../LocalStore/useStore";
import CustomScroll from "../../Component/CustomScroll";

const RechargeHistory = () => {

  const { kv, set } = useStore();
  const rechargeHistory = kv.rechargehistory || [];

  const [showPicker, setShowPicker] = useState(false);
  const [date, setDate] = useState("");
  const [displayDate, setDisplayDate] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState(rechargeHistory);
  const [totalPages, setTotalPages] = useState(1);

  const columns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Time",
        accessor: "time",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">₹ {value}</p>;
        },
      },
      {
        Header: "Trans ID",
        accessor: "transaction_id",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <p className={`${value == "Pending" ? "err-btn" : "appr-btn"}`}>
                {value}
              </p>
            </div>
          );
        },
      },
    ],
    []
  );

  const getList = async (date_) => {
    try {
      setDisplayDate(date_);
      let url_ = `?page=${pageNumber}`;
      if (date_) {
        url_ = url_ + `&date=${moment(date_).format("YYYY-MM-DD")}`;
      }
      const res = await get(`${URLS.RECHARGE}s` + url_);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        setData(res?.data);
        set("rechargehistory", res?.data);
        setTotalPages(res?.pagination?.total_pages || 1);
      }
    } catch (err) {
      Toast("Failed to load history");
    }
  };

  useEffect(() => {
    getList();
  }, [pageNumber]);

  return (
    <div style={{ paddingBottom: 40 }} className="dashRightView-foots ">
      <CustomScroll >
        <div style={{ marginBottom: 50 }} className=" containers_list ">
          <div className=" p-4">
            <DateRange
              fromDate={displayDate}
              onChange={(dates) => getList(dates)}
            />
          </div>
          <Table
            columns={columns}
            setPageno={setPageNumber}
            pagecount={totalPages}
            data={data}
            show={false}
          />
        </div>
      </CustomScroll>
      <div className="d-flex ac-jc w-100">
        <ScreenPagination totalPages={totalPages} show={false} />
      </div>
    </div>
  );
};

export default RechargeHistory;
